import {
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  TextField,
} from "@mui/material";
import React from "react";
import Button from "./Button";
const PaymentStatusDialog = ({
  open,
  onClose,
  payment,
  emptyPay,
  Currency,
  Payment,
  handleCurrencyChange,
  handlePaymentChange,
  handlePaymentStatusChange,
  handleCreatePayment,
  HandleStatusConfirm,
}) => {
  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>Payment Status</DialogTitle>
      <DialogContent>
        <Box sx={{ margin: "10px" }}>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={4}>
              <FormControl fullWidth sx={{ marginBottom: "16px" }}>
                <InputLabel shrink={true} sx={{ backgroundColor: "white" }}>
                  Currency
                </InputLabel>
                <Select
                  value={payment.CurrencyStatus}
                  onChange={handleCurrencyChange}
                >
                  {Object.entries(Currency).map(([key, value]) => (
                    <MenuItem key={key} value={value}>
                      {value}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={8}>
              <TextField
                label="Total Amount"
                name="totalAmount"
                value={payment.totalAmount}
                onChange={handlePaymentChange}
                fullWidth
                style={{ marginBottom: "8px" }}
              />
            </Grid>
            {!emptyPay && (
              <>
                <Grid item xs={12} sm={12}>
                  <FormControl fullWidth sx={{ marginBottom: "16px" }}>
                    <InputLabel shrink={true} sx={{ backgroundColor: "white" }}>
                      Payment status
                    </InputLabel>
                    <Select
                      value={payment.paymentStatus}
                      onChange={handlePaymentStatusChange}
                    >
                      {Object.entries(Payment).map(([key, value]) => (
                        <MenuItem key={key} value={value}>
                          {value}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
              </>
            )}
          </Grid>
        </Box>
      </DialogContent>
      <DialogActions
        style={{ display: "flex", justifyContent: "center", gap: "2px" }}
      >
        <Button
          backgroundColor="#CCD3DA"
          color="#000"
          hoverColor="#A9A9A9"
          text="Cancel"
          width="150px"
          onClick={onClose}
        />
        {emptyPay ? (
          <Button width="150px" text="Confirm" onClick={handleCreatePayment} />
        ) : (
          <Button width="150px" text="Confirm" onClick={HandleStatusConfirm} />
        )}
      </DialogActions>
    </Dialog>
  );
};

export default PaymentStatusDialog;
